import {combineReducers} from 'redux'

import {adminReducer, initialAdminState} from './AdminReducer'
import {authReducer, initialAuthState} from './AuthReducer'
import {initialPlanState, planReducer} from './PlanReducer'
import {initialProductsState, productReducer} from './ProductReducer'
import {initialReportState, reportReducer} from './ReportReducer'
import {initialUserState, userReducer} from './UserReducer'
import type {RootState} from '../store'
import {initialServicePricesState, servicePriceReducer} from "./ServicePriceReducer";

export const reducers = {
  admin: adminReducer,
  auth: authReducer,
  plan: planReducer,
  products: productReducer,
  report: reportReducer,
  servicePrices: servicePriceReducer,
  user: userReducer
}

/**
 * Initial store state.
 */
export const initialRootState: RootState = {
  admin: initialAdminState,
  auth: initialAuthState,
  plan: initialPlanState,
  products: initialProductsState,
  report: initialReportState,
  servicePrices: initialServicePricesState,
  user: initialUserState
}

/**
 * Type of all application reducers.
 */
export type AppReducers = typeof reducers

const rootReducer = combineReducers(reducers)

export default rootReducer
